var map = {
	"./ANIMALS.css": 72019,
	"./ANIME.css": 52978,
	"./CLASSIC.css": 96762,
	"./COUNTRIES.css": 82714,
	"./CUSTOM_THEME.css": 43955,
	"./DRAGONBALL.css": 20395,
	"./FOODS.css": 17219,
	"./HALLOWEEN.css": 81670,
	"./HEARTHSTONE.css": 61414,
	"./HISTORICAL_FIGURES.css": 68119,
	"./LEAGUE_OF_LEGENDS.css": 83293,
	"./MELAGOODO.css": 31708,
	"./POKEMON.css": 1976,
	"./POKEMON_GEN2.css": 40127,
	"./POKEMON_GEN3.css": 5613,
	"./POKEMON_GEN4.css": 16617,
	"./POKEMON_GEN5.css": 50510,
	"./POKEMON_GEN6.css": 11552,
	"./POKEMON_GEN7.css": 28110,
	"./SIMPSONS.css": 76191,
	"./SMORFIA.css": 16029,
	"./SOCCER_PLAYERS.css": 79735,
	"./SUPERHEROES.css": 83946,
	"./TV_SERIES.css": 45239,
	"./WINTER.css": 22859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85171;